<article>
  <h1>
    <img src="/assets/podcast.svg" />
    Podcasts
  </h1>

  <app-spinner *ngIf="!shows"></app-spinner>
  <section class="podcasts" *ngIf="shows">
    <tyt-podcast-item *ngFor="let show of shows" [attr.data-show]="show.id" [class.above-the-fold]="isAboveFold(show)"
      [class.active]="topShowId === show.id" [show]="show">
    </tyt-podcast-item>
  </section>
</article>